import { Fragment } from 'react';

import PropTypes from 'prop-types';

import useTrls from 'hooks/translation/useTrls';

import Label from 'components/Label';

import { InvoiceDreamPayerType } from 'store/models/invoices';

const KMNumber = ({ userId, number, payerType, withLabel }) => {
    const trl = useTrls();

    if (payerType === InvoiceDreamPayerType.HH) {
        return trl('admin.Invoices.InvoicesTable.Invoice.HH');
    }
    if (payerType === InvoiceDreamPayerType.Gift) {
        return trl('admin.Invoices.InvoicesTable.Invoice.gift');
    }
    if (!number || !userId) {
        return null;
    }
    const kmNumber = `${trl('admin.Invoices.InvoicesTable.Invoice.number')}/${userId}/${number}`;
    if (withLabel) {
        return <Label type="success">{kmNumber}</Label>;
    }
    return <Fragment>{`${kmNumber}`}</Fragment>;
};

KMNumber.propTypes = {
    userId: PropTypes.number,
    number: PropTypes.number,
    payerType: PropTypes.string,
    withLabel: PropTypes.bool,
};

KMNumber.defaultProps = {
    withLabel: false,
};

export default KMNumber;
